import { render, staticRenderFns } from "./LargeLabel.vue?vue&type=template&id=0cac6b88&scoped=true&"
import script from "./LargeLabel.vue?vue&type=script&lang=js&"
export * from "./LargeLabel.vue?vue&type=script&lang=js&"
import style0 from "./LargeLabel.vue?vue&type=style&index=0&id=0cac6b88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cac6b88",
  null
  
)

export default component.exports